import { FC } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { Link as RouterLink } from 'react-router-dom';

import { ON_GO_ACCESS } from 'constants/onGoAccess.config';

type OnGoFreePlanDialogProps = {
  open: boolean;
  onClose: () => void;
};

const { copy, premiumSubscribePath } = ON_GO_ACCESS;
const { entryModal } = copy;

const OnGoFreePlanDialog: FC<OnGoFreePlanDialogProps> = ({ open, onClose }) => (
  <Dialog aria-labelledby='on-go-free-plan-dialog-title' onClose={onClose} open={open}>
    <DialogTitle id='on-go-free-plan-dialog-title'>W głowie</DialogTitle>
    <DialogContent>
      <Typography variant='body1'>
        {entryModal.beforeLink}
        <Link color='primary' component={RouterLink} onClick={onClose} to={premiumSubscribePath}>
          {entryModal.linkText}
        </Link>
        {entryModal.afterLink}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button color='primary' onClick={onClose} variant='contained'>
        {entryModal.closeButton}
      </Button>
    </DialogActions>
  </Dialog>
);

export default OnGoFreePlanDialog;
